import { right } from '@popperjs/core';
import React from 'react';
import { toast, ToastContainer  } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Button} from "react-bootstrap";

interface toastMessage {
    id:number
    type:string,
    msg:string | JSX.Element,
}

const MsgDoc = ({msg, browserLink}) => (
    <div className="Toastify__toast-body" style={{padding:'0'}} onClick={() => {var d = browserLink;d.openDocument();}}>
        <div className="Toastify__toast-icon Toastify--animate-icon Toastify__zoom-enter">
            {msg.type === "pdf" ?
                <i className="fa-solid fa-file-pdf"></i>
                : <i className="fa-solid fa-file-word"></i>
            }
        </div>

        <div>
             {msg.msg}
        </div>
    </div>
)

const MsgDocOnlineDesktop = ({msg, browserLink}) => (
    <div>
        <div>{msg.type === "pdf" ?
                <i className="fa-solid fa-file-pdf"></i>
                : <i className="fa-solid fa-file-word"></i>
            } {msg.msg}</div>
        <div style={{alignContent:right}}>
            <Button variant="link" onClick={
                () => {
                    var d = browserLink;
                    d.openDocument();
                }
            }
            >Online</Button>
            <Button variant="link" onClick={
                () => {
                    var d = browserLink;
                    d.openDocument(false, true);
                }
            }>Desktop</Button>
        </div>
    </div>
    )

export function displayToastMsg(msg:toastMessage, clickfunc, options?: { autoClose?: number }) {
    var type = msg.type;
    const toastOptions = options || {};
    
    if (clickfunc > '' && (type !== 'error' && type !== 'load')){
        if (type === "onlineword"){
            toast(<MsgDocOnlineDesktop msg={msg} browserLink={clickfunc}/>, toastOptions);
        }else {
            toast(<MsgDoc msg={msg} browserLink={clickfunc}/>, toastOptions);
        }

    }else {
        switch(type){
            case "error":
                toast.error(msg.msg, toastOptions);
                break;
            case "save":
            case "success":
                toast.success(msg.msg, toastOptions);
                break;
            case "load":
            case "loading":
            case "":
            case "pdf":
            default:
                toast.info(msg.msg, toastOptions);
        } 
    }
}

export function ToastMessaging() {
    return (
        <ToastContainer
            position="bottom-right"
            autoClose={4000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            theme="colored"
        />
    );
}

/*
var lastMsgID:number = 2;
var lddMessages:Array<toastMessage> = [
    {id:1, type:"", msg:"See? Just like this."},
    {id:2, type:"warning", msg: "see, bad bad"}
]

function addMsg(msg:string, type,id:number):void{
    var tmp:toastMessage = {
        id:id,
        type:type,
        msg:msg
    }
    lddMessages.push(tmp);
    lastMsgID = id;
}

function deleteMsg(id:number):void{
    for(var i =0; i < lddMessages.length;i++){
        var msg:toastMessage = lddMessages[i];
        if (msg.id === id){
            lddMessages = lddMessages.splice(i,1);
        }
    }
}

function StackingExample() {
    return (
      <ToastContainer className="position-static" position="bottom-end">
        {lddMessages.map((myMsg:toastMessage) => (
             <Toast bg={myMsg.type}>
                 <Toast.Header closeButton={false} style={{'textAlign':'right'}}>
                 <button type="button" className="ml-2 mb-1 close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                 </Toast.Header>
                 <Toast.Body>{myMsg.msg}
                 </Toast.Body>
             </Toast>
        ))
        }
        
      </ToastContainer>
    );
  }
  
  export default StackingExample;
  */